import { Globe } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CURRENCIES, getCurrency, setCurrency, useCurrency } from "@/lib/currency";

export default function CurrencySelect({ compact = false, testid = "currency-select" }) {
  const { currency } = useCurrency();
  return (
    <Select value={currency} onValueChange={setCurrency}>
      <SelectTrigger
        data-testid={testid}
        className={`bg-[#0A1628] border-[#1E2D4A] text-slate-300 hover:border-[#2E6BFF]/50 transition-colors ${
          compact ? "h-9 w-auto gap-1.5 px-2.5 text-xs font-mono uppercase" : "h-11 w-full"
        }`}
      >
        <Globe className="w-3.5 h-3.5 text-[#5B8CFF] shrink-0" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-[#0A1628] border-slate-700 text-slate-100 max-h-72">
        {CURRENCIES.map(([code, label, name]) => (
          <SelectItem key={code} value={code} data-testid={`currency-option-${code}`}>
            {label} <span className="text-slate-500 text-xs">— {name}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
